// import { useState } from "react";
// import { toast } from "react-toastify";
// import { createTreeSpeciesApi } from "../../apis/treeSpeciesApi";

// export const useAddTreeSpecies = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const addTreeSpecies = async (speciesData) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Creating tree species...");

//     try {
//       const formData = new FormData();

//       // Add all non-file fields
//       Object.entries(speciesData).forEach(([key, value]) => {
//         if (key === "images") return; // handle separately

//         // Only append if value is meaningful
//         if (value !== undefined && value !== null && value !== "") {
//           formData.append(key, value);
//         }
//       });

//       // Handle images separately
//       if (Array.isArray(speciesData.images)) {
//         speciesData.images.forEach(file => {
//           formData.append("images", file);
//         });
//       }

//       const newSpecies = await createTreeSpeciesApi(formData);

//       toast.update(toastId, {
//         render: "Tree species added successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 4000,
//       });

//       return newSpecies;
//     } catch (err) {
//       const msg =
//         err.response?.data?.detail ||
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to create tree species";

//       toast.update(toastId, {
//         render: msg,
//         type: "error",
//         isLoading: false,
//         autoClose: 6000,
//       });

//       setError(msg);
//       throw new Error(msg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { addTreeSpecies, loading, error };
// };


import { useState } from "react";
import { toast } from "react-toastify";
import { createTreeSpeciesApi } from "../../apis/treeSpeciesApi";

export const useAddTreeSpecies = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
  // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to create tree species.",
    };
  };

  const addTreeSpecies = async (speciesData) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Creating tree species...");

    try {
      const formData = new FormData();

      // Append non-file fields
      Object.entries(speciesData).forEach(([key, value]) => {
        if (key === "images") return;

        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      });

      // Append images
      if (Array.isArray(speciesData.images)) {
        speciesData.images.forEach((file) => {
          formData.append("images", file);
        });
      }

      const response = await createTreeSpeciesApi(formData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Tree Species Created</strong>
            <div>Tree species added successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 4000,
      });

      return response.data; // assuming axios response
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 6000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { addTreeSpecies, loading, error };
};